import { render, staticRenderFns } from "./RecipeModal.vue?vue&type=template&id=3b767d4e"
import script from "./RecipeModal.vue?vue&type=script&lang=js"
export * from "./RecipeModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports